import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import { i18n } from './assets/i18n/i18n'
import './services/vee-validate'
import { localeChanged } from 'vee-validate'
import 'vue-select/dist/vue-select.css'
import '@/assets/css/main.css'
import '@/scss/app.scss'
import 'material-icons/iconfont/material-icons.css'
import * as firebase from 'firebase/app'
import Constants from '@/plugins/constants'
import moment from 'moment'
import Hotjar from 'vue-hotjar'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faApplePay, faGooglePay } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faApplePay)
library.add(faGooglePay)
import VueConfirmDialog from 'vue-confirm-dialog'
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

import PrettyCheckbox from 'pretty-checkbox-vue'

Vue.use(PrettyCheckbox)

Vue.prototype.moment = moment

const cookieAcceptedValue =
  localStorage.getItem('cookie:accepted') == 'true' ? true : false

Vue.use(Hotjar, {
  id: process.env.VUE_APP_HOTJAR_ID,
  isProduction: cookieAcceptedValue
})

var firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_FIREBASE_APPID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENTID
}

firebase.initializeApp(firebaseConfig)

let app

import api from './plugins/api'
Vue.prototype.$http = api
api.defaults.timeout = 10000

api.interceptors.request.use(
  async function(config) {
    try {
      const storageToken = localStorage.getItem('access_token')
      if (storageToken) {
        config.headers.common['Authorization'] = storageToken
      }
      return config
    } catch (error) {
      console.log(error)
      await store.dispatch('logoutUser')
      window.location.reload()
    }
  },
  error => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  function(response) {
    return response
  },
  async function(error) {
    if (error.response.status == 401) {
      await store.dispatch('logoutUser')
      window.location.reload()
    }
    return Promise.reject(error)
  }
)
api.interceptors.request.use(
  function(config) {
    store.commit('LOADING_STATE', true)
    return config
  },
  function(error) {
    store.commit('LOADING_STATE', false)
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  function(config) {
    store.commit('LOADING_STATE', false)
    return config
  },
  function(error) {
    store.commit('LOADING_STATE', false)
    return Promise.reject(error)
  }
)
Vue.use(Constants)

import Multiselect from 'vue-multiselect'

// register globally
Vue.component('Multiselect', Multiselect)

import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css'
import vuetify from './plugins/vuetify'

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      i18n,
      render: h => h(App),
      vuetify,
      mounted: appMounted
    }).$mount('#app')
  }
})

// eslint-disable-next-line no-unused-vars
const unsync = sync(store, router)

Vue.config.productionTip = false

Vue.prototype.$paddlelib = Paddle

if (process.env.VUE_APP_FEATURE_STAGE == 'dev')
  Paddle.Environment.set('sandbox')
Paddle.Initialize({
  token: process.env.VUE_APP_PADDLE_KEY,
  eventCallback: function(data) {
    if (data.name == 'checkout.completed') {
      console.log(data)
    } else if (data.name == 'checkout.closed') {
      console.log('closed')
      router.replace('/profile')
    }
  }
})

function appMounted() {
  let uri = window.location.search.substring(1)
  let params = new URLSearchParams(uri)
  const lang = params.get('lang')
  const browserLanguage = navigator.language.split('-')[0]
  let localeToSet = store.state.lang ? store.state.lang : 'it'
  if (browserLanguage && !store.state.lang) {
    localeToSet =
      browserLanguage == 'en' || browserLanguage == 'it'
        ? browserLanguage
        : 'it'
  }
  if (lang) {
    localeToSet = lang == 'en' || lang == 'it' ? lang : 'it'
  }
  i18n.locale = localeToSet
  localeChanged()
  store.commit('CHANGE_LANG', { lang: localeToSet })
}
